import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CategoryItem, SubCategoryItem } from 'src/app/request-v2/models/create-request.dto';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-subcategory-selection',
    templateUrl: './subcategory-selection.component.html',
    styleUrls: ['./subcategory-selection.component.scss'],
})
export class SubcategorySelectionComponent implements OnChanges, OnInit, OnDestroy {
    @Input() selectedCategory: CategoryItem | null = null;

    @Input() selectedSubcategory: SubCategoryItem | null = null;

    @Output() subcategorySelected = new EventEmitter<SubCategoryItem>();

    searchQuery = '';

    filteredSubcategories: SubCategoryItem[] = [];

    loading = false;

    private searchSubject = new Subject<string>();

    private searchSubscription: Subscription;

    ngOnInit(): void {
        this.setupSearchSubscription();
        this.updateFilteredSubcategories();
    }

    ngOnChanges(_changes: SimpleChanges): void {
        if (this.selectedCategory && this.selectedCategory.subCategories && this.selectedSubcategory) {
            this.selectedCategory.subCategories.forEach((subcategory) => {
                subcategory.selected = subcategory._id === this.selectedSubcategory?._id;
            });
        }
        this.updateFilteredSubcategories();
    }

    ngOnDestroy(): void {
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
    }

    setupSearchSubscription(): void {
        this.searchSubscription = this.searchSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe((query) => {
            this.filterSubcategories(query);
        });
    }

    onSearchChange(): void {
        this.searchSubject.next(this.searchQuery);
    }

    filterSubcategories(query: string): void {
        if (!this.selectedCategory || !this.selectedCategory.subCategories) {
            this.filteredSubcategories = [];
            return;
        }

        const lowerCaseQuery = query.toLowerCase().trim();
        if (!lowerCaseQuery) {
            this.filteredSubcategories = [...this.selectedCategory.subCategories];
        } else {
            this.filteredSubcategories = this.selectedCategory.subCategories.filter((subcategory) => subcategory.name.toLowerCase().includes(lowerCaseQuery));
        }
    }

    updateFilteredSubcategories(): void {
        if (this.selectedCategory && this.selectedCategory.subCategories) {
            this.filterSubcategories(this.searchQuery);
        } else {
            this.filteredSubcategories = [];
        }
    }

    selectSubcategory(subcategory: SubCategoryItem): void {
        if (this.selectedCategory?.subCategories) {
            this.selectedCategory.subCategories.forEach((item) => {
                item.selected = false;
            });
        }

        subcategory.selected = true;
        this.subcategorySelected.emit(subcategory);
    }
}
